export default defineNuxtRouteMiddleware((to, from) => {
  to.meta.keepalive = true
  from.meta.keepalive = true
})
